import { Device } from '@capacitor/device';
import CryptoJS from 'crypto-js';

// Hashing function using SHA-256
export async function hashString(str) {
    if (window.crypto && window.crypto.subtle) {
        try {
            const encoder = new TextEncoder();
            const data = encoder.encode(str);
            const hashBuffer = await crypto.subtle.digest('SHA-256', data);
            return Array.from(new Uint8Array(hashBuffer))
                .map(b => b.toString(16).padStart(2, '0'))
                .join('');
        } catch (error) {
            console.error('Error hashing string:', error);
            return null;
        }
    } else {
        console.warn('Crypto API not available, using fallback hashing method');
        return CryptoJS.SHA256(str).toString(CryptoJS.enc.Hex);
    }
}

// Function to get the device ID (hashed UUID)
export async function getDeviceId() {
    try {
        const info = await Device.getId(); // Get unique device ID
        return hashString(info.identifier);
    } catch (error) {
        console.error('Error getting device ID:', error);
        return null;
    }
}

export async function getDeviceName() {
  try {
    const info = await Device.getInfo();
    const platform = info.platform || 'web';
    const os = info.operatingSystem || 'Unknown OS';
    const model = info.model || '';
    const manufacturer = info.manufacturer || '';

    if (platform === 'web') {
      return detectWebDeviceName();
    }

    // For Android and iOS, return a friendly device name
    if (platform === 'android' || platform === 'ios') {
      const deviceName = `${manufacturer} ${model}`.trim();
      return deviceName || `${capitalize(os)} Device`;
    }

    return `${capitalize(os)} Device`;
  } catch (error) {
    console.error('Error getting device name:', error);
    return 'Unknown Device';
  }
}

// 🔍 Detect web device name using the User-Agent
function detectWebDeviceName() {
  const ua = navigator.userAgent;

  if (/Windows NT/.test(ua)) return detectWindowsVersion();
  if (/Mac OS X/.test(ua)) return 'macOS Device';
  if (/iPhone/.test(ua)) return 'iPhone (Web)';
  if (/iPad/.test(ua)) return 'iPad (Web)';
  if (/Android/.test(ua)) return 'Android Device (Web)';
  if (/Linux/.test(ua)) return 'Linux Device';

  return 'Web Device';
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// 🛠 Detect Windows version using `navigator.userAgent`
function detectWindowsVersion() {
    const userAgent = navigator.userAgent;

    if (userAgent.includes("Windows NT 11.0")) return "Windows 11";
    if (userAgent.includes("Windows NT 10.0")) return "Windows 10";
    if (userAgent.includes("Windows NT 6.3")) return "Windows 8.1";
    if (userAgent.includes("Windows NT 6.2")) return "Windows 8";
    if (userAgent.includes("Windows NT 6.1")) return "Windows 7";
    if (userAgent.includes("Windows NT 6.0")) return "Windows Vista";
    if (userAgent.includes("Windows NT 5.1") || userAgent.includes("Windows XP")) return "Windows XP";

    return "Windows (Unknown Version)";
}
